<!--聊天界面，包括输入框和内容列表，不过数据是从外界传进来的-->
<template>
	<div class="chatListBody">
		<div class="infoList custom-scrollbar" ref="infoList">
			<template v-for="(item, index) in dataList">
				<msgInfo v-if="['left','right'].includes(item.type)" :index="index" :messageType="item.messageType" :isRightPart="item.type == 'right'" :headPic="item.headPic"
				 :userName="item.userName" :messageBody="item.messageBody" :imgPath="item.imgPath" :filePath="item.filePath"
				 :fileIcoPath="fileTypeToIcoPath[item.fileType]"></msgInfo>
				<systemInfo v-else-if='item.type == "center"' :messageBody="item.messageBody"></systemInfo>
			</template>
		</div>
		<div class="inputDiv">
			<div class="buttonLine" style="padding: 0;">
				<img :src="getResourcesByName('/chat/ico_image.svg')" @click="$refs.imagePicker.click()" title="上传图片">
				<input type="file" @change="getFile" accept="image/png, image/jpeg" style="display: none;" ref="imagePicker" />
				<img :src="getResourcesByName('/chat/ico_file.svg')" @click="$refs.filePicker.click()" title="上传文件">
				<img :src="getResourcesByName('/chat/ico_location.png')" @click="getLocation" title="上传位置信息">
				<input type="file" @change="getFile" :accept="acceptList" style="display: none;" ref="filePicker" />
				<!--<img v-show="isMyNode" :src="getResourcesByName('/chat/ico_confirm.svg')" @click="$emit('confirm')" title="通过审核">-->
				<img v-show="isMyNode" :src="getResourcesByName('/chat/ico_delete.svg')" @click="$emit('backTo')" title="回滚">
				<img v-show="isMyNode" :src="getResourcesByName('/chat/ico_leader.svg')" @click="$emit('changeLeader')" title="转派">
				<img v-show="isMyNode" :src="getResourcesByName('/chat/ico_add.svg')" @click="$emit('addParticipants')" title="增加抄送人">
				<img v-show="isMyNode" :src="getResourcesByName('/chat/ico_remove.svg')" @click="$emit('removeParticipants')" title="移除抄送人">
			</div>
			<textarea rows="4" v-model="nowText"></textarea>
			<div v-show="isMyNode" class="nomalButton" @click="$emit('confirm')">完成，通过审核</div>
			<div class="nomalButton" @click="uploadText">发送</div>
		</div>
		<div id="locationmap"></div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import msgInfo from '@/components/module/chat/msgInfo.vue'
	import systemInfo from '@/components/module/chat/systemInfo.vue'
	export default {
		components: {
			msgInfo,
			systemInfo,
		},
		props: {
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			isMyNode:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				nowText: undefined,
			}
		},
		created() {},
		mounted() {
			this.moveToBottom()
		},
		destroyed() {},
		computed: {
			acceptList() {
				return Object.keys(this.$store.resourcesStore.state.fileTypeToTypeEnum)
			},
			fileTypeToIcoPath() {
				return resourcesStore.state.fileTypeToIcoPath
			},
			getResourcesByName() {
				return resourcesStore.getters.getResourcesByName
			},
		},
		watch: {
			dataList(nv, ov) {
				this.moveToBottom()
			}
		},
		methods: {
			uploadText() {
				this.$emit('uploadText', this.nowText)
				this.nowText = undefined
			},
			getFile(event) {
				var file = event.target.files[0]
				var formData = new FormData()
				// 向 formData 对象中添加文件
				formData.append('file', file)
				formData.append("type", this.$store.resourcesStore.state.fileTypeToTypeEnum[file.type])
				this.$emit('pickerFile', formData)
			},
			moveToBottom() {
				setTimeout(() => {
					if (this.$refs.infoList != undefined) {
						this.$refs.infoList.scrollTop = this.$refs.infoList.scrollHeight
					}
				}, 500)
			},
			getLocation() {
				this.$dialogMethod.showLoading('正在发送定位')
				var nowPage = this
				var map = new BMap.Map("locationmap")
				var point = new BMap.Point(116.331398,39.897445)
				map.centerAndZoom(point,12)
				
				var geolocation = new BMap.Geolocation()
				geolocation.getCurrentPosition(function(r){
					if(this.getStatus() == BMAP_STATUS_SUCCESS){
						var mk = new BMap.Marker(r.point)
						map.addOverlay(mk)
						map.panTo(r.point)
						// nowPage.$dialogMethod.showMessage('您的位置：'+r.point.lng+','+r.point.lat)
						nowPage.$emit('sendLocation', r.point)
					}
					else {
						nowPage.$dialogMethod.showMessage('failed'+this.getStatus())
					}
				},{enableHighAccuracy: true})
			},
		}
	}
</script>

<style scoped>
	.chatListBody {
		height: 460px;
		background: white;
		border: #E2E2E1 solid 1px;
	}

	.infoList {
		height: calc(100% - 230px);
		overflow-y: auto;
		overflow-x: hidden;
		margin: 0 10px;
		padding-bottom: 10px;
	}

	.inputDiv {
		height: 160px;
		border-top: #E2E2E1 solid 1px;
	}

	.inputDiv>textarea {
		min-width: calc(100% - 20px);
		height: 80px;
		border: none;
		list-style: none;
		resize: none;
		outline: none;
		padding: 0 10px;
	}

	.nomalButton {
		margin-top: 5px;
		float: right;
	}

	.buttonLine img {
		width: 20px;
		height: 20px;
		cursor: pointer;
		margin-left: 10px;
	}
</style>
